import { Inject } from '@angular/core';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS } from '@angular/material-luxon-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DateTime } from 'luxon';

export class CustomLuxonDateAdapter extends LuxonDateAdapter {
  constructor(
    @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    @Inject(MAT_LUXON_DATE_ADAPTER_OPTIONS) options: any
  ) {
    super(matDateLocale, options);
  }

  /**
   * Tenta converter o valor informado em um objeto DateTime.
   * Se for uma string não vazia, utiliza o formato informado (se houver) ou 'dd/MM/yyyy' como padrão.
   */
  override parse(value: any, parseFormat: string): DateTime | null {
    if (typeof value === 'string' && value.trim().length > 0) {
      // Usa o formato recebido ou, se não houver, o padrão 'dd/MM/yyyy'
      const dateFormat = parseFormat || 'dd/MM/yyyy';
      const dateTimeFromString = DateTime.fromFormat(value, dateFormat, { locale: this.locale });
      return dateTimeFromString.isValid ? dateTimeFromString : null;
    }
    return value ? DateTime.fromJSDate(value) : null;
  }

  /**
   * Converte um objeto DateTime em string, utilizando o formato informado
   * (ou 'dd/MM/yyyy' se nenhum formato for informado).
   */
  override format(date: DateTime, displayFormat: string): string {
    if (!this.isValid(date)) {
      throw new Error('Invalid Date');
    }
    const formatToUse = displayFormat || 'dd/MM/yyyy';
    return date.setLocale(this.locale).toFormat(formatToUse);
  }
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
